// Third party libraries
import * as $ from 'jquery';
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js'

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Services
import trackingHistoryService from '@/app/services/telstra/tracking-history/tracking-history-service.js';

export default {
	name: 'ModalModifyTracking',
	mixins: [ toastMessageMixins ],
	props: {
		modalContent: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			serialNumber: '',
			
		}
	},
	computed: {
		validationRules() {
			let fields = {
				serialNumber: {}
			};

			fields = vuelidateUtil.setRequiredValidation(fields, 'serialNumber');
			return fields;
		},
		isInvalid() {
			return this.$v.$invalid || this.serialNumber === this.modalContent.trackingSerialNumber;
		}
	},
	watch: {
		'modalContent': {
			handler(newVal) { 
				this.$v.$reset();
				if (newVal) {
					this.serialNumber = this.modalContent.trackingSerialNumber;
				}
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		show() {
			$('#trackingModal').modal('show');
		},
		close() {
			$('#trackingModal').modal('hide');
		},
		confirmEditTracking() {
			if (this.isInvalid) {
				return;
			}

			let body = {
				serialNumber: this.serialNumber
			};
			// API call for update serial number
			trackingHistoryService.putSerialNumberTracking(this.modalContent.id, body)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(null, this.toastMessages.tracking(this.serialNumber).SUCCESS_UPDATE_SERIAL_NUMBER);
						this.$emit('getTableContent');
						this.close();
					} else {
						this.showAPIErrorToast(this.toastMessages.tracking().ERROR_UPDATE_SERIAL_NUMBER, res);
					}
				});
		}
	},
	validations() {
		return this.validationRules;
	}
}